export const localizeBreadcrumbUrl = (url: string, homeUrl: string): string => {
  const localeRoot = homeUrl.replace(/\/$/, "");
  const localizedRoot = localeRoot ? `${localeRoot}/` : "/";
  const pathname = new URL(url, "https://ourplace.local").pathname;

  if (pathname === localeRoot) {
    return localizedRoot;
  }

  if (pathname.startsWith(localizedRoot)) {
    return pathname;
  }

  return `${localizedRoot}${pathname.replace(/^\/+/, "")}`;
};
